<!--Header-->
<div class="modal-header text-center" style="color: white;background-color: #0d47a1">
  <h4 class="modal-title w-100">ENVIO DE CORREO DE PRUEBA</h4>
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClosemodal()">
    <span aria-hidden="true" class="white-text">&times;</span>
  </button>
</div>
<div class="modal-body">
  <mdb-card>
        <mdb-card-body>
          <div class="form-row mb-3">
            <div class="col-3">Asunto:</div>
            <div class="col-9">
              <input mdbInput type="text" maxlength="200"  class="form-control" [(ngModel)]="x_asunto" placeholder="" readonly>
            </div>
          </div>
            <div class="form-row mb-3">
              <div class="col-3">Destinatario:</div>
              <div class="col-7">
                <input mdbInput type="text" maxlength="200"  class="form-control" [(ngModel)]="maeUsuarioE.x_usuario" readonly>
              </div>
              <div class="col-2">
                  <span>@bnp.gob.pe</span>
              </div>
            </div>

            <div class="form-row mb-3">
              <div class="col-3">Curso:</div>
              <div class="col-9">
                <mat-form-field class="example-full-width w-100">
                  <mat-label>Buscar</mat-label>
                  <input type="text"
                        aria-label="Constancia"
                        matInput
                        [formControl]="myControl"
                        [matAutocomplete]="auto">
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option (click)="onSelected(null)" [value]="''">
                          {{"Seleccione"}}
                    </mat-option>
                    <mat-option (click)="onSelected(listConstancia)" *ngFor="let listConstancia of listConstanciasFil | async" [value]="listConstancia.x_curso">
                      {{listConstancia.x_curso}}
                    </mat-option>
                  </mat-autocomplete>
              </mat-form-field>
              </div>
           </div>
      </mdb-card-body>
  </mdb-card>
  <br>
        <!--Footer-->
  <div class=" d-flex justify-content-center">
         <button mdbBtn type="button" (click)="onEnviar()" size="sm" class="btn btn-blue btn-rounded" mdbWavesEffect>
       <mdb-icon fas icon="paper-plane" class="mr-1"></mdb-icon>Enviar</button>
  </div>
</div>
